export const clTaskSelector = (state) => state.clTask;

export const taskSummarySelector = (state) => clTaskSelector(state).taskSummary;
export const todayDailyTasksSelector = (state) =>
  clTaskSelector(state).todayDailyTasks;
export const taskLoadingSelector = (state) => clTaskSelector(state).taskLoading;
export const abandonedCartDataSelector = (state) =>
  clTaskSelector(state).abandonedCartData;
export const abandonedBusinessTipsSelector = (state) =>
  clTaskSelector(state).abandonedBusinessTips;
export const abandonedFeedbackSelector = (state) =>
  clTaskSelector(state).abandonedFeedback;
export const walletCartDataSelector = (state) =>
  clTaskSelector(state).walletCartData;
export const walletBusinessTipsSelector = (state) =>
  clTaskSelector(state).walletBusinessTips;
export const walletFeedbackSelector = (state) =>
  clTaskSelector(state).walletFeedback;
export const promotionCartDataSelector = (state) =>
  clTaskSelector(state).promotionCartData;
export const promotionBusinessTipsSelector = (state) =>
  clTaskSelector(state).promotionBusinessTips;
